export default {
  profileInfoHead: {
    height: '140px',
    padding: '22px'
  }
}
